const fontStack = (fonts) => fonts.join(',');
const SERIF = ['merriweather', 'Times New Roman', 'serif'];
const SANS_SERIF = [
    'aktiv-grotesk',
    'Helvetica',
    'Arial',
    'sans-serif',
    'Apple Color Emoji'
];
const TERRACOTTA = '#EF4631';
const SANDY_BROWN = '#F3A258';
const SHAKESPEARE = '#53BED0';
const SAN_MARINO = '#5267B4';
const GRAY_1 = '#3C3A3B';
const GRAY_2 = '#5F5D5E';
const GRAY_3 = '#858384';
const GRAY_4 = '#ACAAAB';
const GRAY_5 = '#D6D3D5';
const GRAY_6 = '#EDEDED';
export const onHoverAlpha = 0.07;
export const onClickAlpha = 0.14;
const theme = {
    borderWidths: [0, '1px', '2px', '4px', '8px'],
    fonts: {
        h1: fontStack(SERIF),
        h2: fontStack(SERIF),
        h3: fontStack(SANS_SERIF),
        h4: fontStack(SERIF),
        h5: fontStack(SANS_SERIF),
        h6: fontStack(SANS_SERIF),
        body: fontStack(SANS_SERIF),
        sansSerif: fontStack(SANS_SERIF),
        serif: fontStack(SERIF)
    },
    fontWeights: {
        light: 300,
        normal: 400,
        bold: 700
    },
    fontSizes: ['16px', '20px', '22px', '28px', '32px', '40px'],
    lineHeights: {
        normal: '1.2',
        medium: '1.5'
    },
    space: [
        '0',
        '4px',
        '8px',
        '16px',
        '24px',
        '32px',
        '40px',
        '48px',
        '64px',
        '80px',
        '96px',
        '112px',
        '128px'
    ],
    colors: {
        brand: TERRACOTTA,
        terracotta: TERRACOTTA,
        sandybrown: SANDY_BROWN,
        shakespeare: SHAKESPEARE,
        sanmarino: SAN_MARINO,
        accent: [TERRACOTTA, SANDY_BROWN, SHAKESPEARE, SAN_MARINO],
        gray: [GRAY_1, GRAY_2, GRAY_3, GRAY_4, GRAY_5, GRAY_6]
    }
};
export default theme;
//# sourceMappingURL=theme.js.map